export default __webpack_public_path__ + "7191ea0b60883ccf7987f7ccc2bfb362.svg";